module.exports = __webpack_public_path__ + "img/eagleWingsLogo@3x.de465dfa.webp";